module.exports = __webpack_public_path__ + "img/redis.f53588ba.svg";